import { CircularProgress, styled } from "@mui/material";
import { Box } from "@mui/system";

export function FullscreenLoader() {
  return (
    <StyledBox>
      <CircularProgress color="success" />
    </StyledBox>
  );
}

const StyledBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
